export default __webpack_public_path__ + "2a73eaf1608683d117b10c45e389feb8.png";